import { InputChangeEventDetail, IonIcon, IonInput, IonSelect, IonSelectOption } from '@ionic/react';
import { IonInputCustomEvent } from '@ionic/core';
import { RefObject } from 'react';
import { closeOutline } from 'ionicons/icons';
import { SupportedPhoneCountry, SupportedPhoneCountryId } from '../../../common/phoneCountries';

interface MobileNumberFieldProps {
  value: string;
  onChange: (event: IonInputCustomEvent<InputChangeEventDetail>) => void;
  maxLength: number;
  placeholder: string;
  errorMessage?: string;
  errorClassName?: string;
  inputId?: string;
  dataCy?: string;
  inputRef?: RefObject<HTMLIonInputElement>;
  selectedCountryId?: SupportedPhoneCountryId;
  selectedCountryDialCode?: string;
  onCountryChange?: (countryId: SupportedPhoneCountryId) => void;
  countryOptions?: SupportedPhoneCountry[];
  onClear?: () => void;
  showClear?: boolean;
}

export const MobileNumberField = ({
  value,
  onChange,
  maxLength,
  placeholder,
  errorMessage,
  errorClassName = 'field-validation-message-failed',
  inputId,
  dataCy,
  inputRef,
  selectedCountryId,
  selectedCountryDialCode,
  onCountryChange,
  countryOptions,
  onClear,
  showClear = false,
}: MobileNumberFieldProps) => {
  const countryDialCode = selectedCountryDialCode ?? '1';
  const canSelectCountry =
    Boolean(selectedCountryId) &&
    Boolean(selectedCountryDialCode) &&
    Boolean(onCountryChange) &&
    Boolean(countryOptions?.length);

  return (
    <>
      <span className="button-text primary-color-text">Mobile Number</span>
      <div className="phone-group">
        <div>
          <div className="input-group country-code">
            {canSelectCountry ? (
              <IonSelect
                className="country-code-select primary-color-text"
                value={selectedCountryId}
                selectedText={`+${countryDialCode}`}
                interface="popover"
                interfaceOptions={{ cssClass: 'country-code-popover' }}
                onIonChange={(event) =>
                  onCountryChange?.(event.detail.value as SupportedPhoneCountryId)
                }
              >
                {countryOptions?.map((country) => (
                  <IonSelectOption key={country.id} value={country.shortLabel}>
                    {country.label}
                  </IonSelectOption>
                ))}
              </IonSelect>
            ) : (
              <span className="primary-color-text">+{countryDialCode}</span>
            )}
          </div>
        </div>
        <div>
          <div className="input-group cy-username-field-group">
            <IonInput
              type="text"
              autocomplete="tel"
              maxlength={maxLength}
              placeholder={placeholder}
              value={value}
              id={inputId}
              data-cy={dataCy}
              onIonChange={onChange}
              ref={inputRef}
            />
            {errorMessage && <div className={errorClassName}>{errorMessage}</div>}
          </div>
          {showClear && value && (
            <button
              type="button"
              className="login-v2-phone-clear"
              onClick={() => {
                onClear?.();
                if (inputRef?.current) inputRef.current.value = '';
              }}
            >
              <IonIcon icon={closeOutline} />
            </button>
          )}
        </div>
      </div>
    </>
  );
};
